import PropTypes from 'prop-types'
import React, { Component } from 'react'
import clsx from 'clsx'

class ImageSlider extends Component {
  constructor (props) {
    super(props)

    this.state = {
      activeIndex: 0
    }

    this.showNextSlide = this.showNextSlide.bind(this)
  }

  componentDidMount () {
    this.interval = setInterval(this.showNextSlide, this.props.interval)
  }

  componentWillUnmount () {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }

  showNextSlide () {
    const nextSlide = (this.state.activeIndex + 1) % this.props.images.length

    this.setState({
      activeIndex: nextSlide
    })
  }

  render () {
    const { activeIndex } = this.state
    const { images } = this.props
    return (
      <div className='slider'>
        {images.map(({ name, src }, index) => (
          <div
            key={name}
            className={clsx(
              'slide',
              index === activeIndex && 'active',
              index === (activeIndex - 1 + images.length) % images.length && 'prev',
              index === (activeIndex + 1) % images.length && 'next'
            )}
          >
            <img src={src} alt={name} />
          </div>
        )) }
      </div>
    )
  }
}

ImageSlider.defaultProps = {
  interval: 5000
}

ImageSlider.propTypes = {
  images: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired
  })).isRequired,
  interval: PropTypes.number
}

export default ImageSlider



// WEBPACK FOOTER //
// ./src/components/image-slider.js